import React, { useState } from 'react';
import { LuDroplets, LuSofa, LuShieldCheck, LuCog, LuLightbulb, LuCheck } from 'react-icons/lu';
import './Services.css';
import Seo from '../components/Seo';

const SERVICES = [
  {
    id: 'exterior',
    title: 'Exterior Wash & Wax',
    tagline: 'Shine that turns heads',
    price: '$XX',
    duration: '~1.5 hrs',
    icon: LuDroplets,
    features: [
      'Full exterior hand wash',
      'Wheel & tire cleaning',
      'Clay bar decontamination',
      'Carnauba wax application',
      'Window & mirror cleaning',
      'Tire dressing',
    ],
  },
  {
    id: 'interior',
    title: 'Interior Deep Cleaning',
    tagline: 'Fresh inside, every time',
    price: '$XX',
    duration: '~2 hrs',
    icon: LuSofa,
    features: [
      'Full vacuum (seats, carpet, trunk)',
      'Dashboard & console wipe-down',
      'Leather conditioning',
      'Steam cleaning for stains',
      'Air vent cleaning',
      'Odor elimination treatment',
    ],
  },
  
  {
    id: 'ceramic',
    title: 'Ceramic Coating',
    tagline: 'Years of protection in one service',
    price: '$XXX+',
    duration: '~6–8 hrs',
    icon: LuShieldCheck,
    features: [
      'Full decontamination wash',
      
      'Professional nano coating application',
      'Hydrophobic protection',
      '2–5 year durability',
      'Certificate of application',
    ],
  },
  {
    id: 'engine',
    title: 'Engine Bay Cleaning',
    tagline: 'Clean under the hood too',
    price: '$XX',
    duration: '~1 hr',
    icon: LuCog,
    features: [
      'Safe degreaser application',
      'Low-pressure rinse',
      'Compressed air dry',
      'Plastic & rubber dressing',
      'Visual inspection included',
      'Safe for all engine types',
    ],
  },
];

export default function Services({ navigate }) {
  const [active, setActive] = useState(null);

  return (
    <div className="services-page">
      <Seo
        title="Services & Pricing | Cardona Auto Detailing"
        description="Wash & wax, deep interior cleaning, paint correction, and ceramic coating. Mobile car detailing in Cookeville and Algood, TN."
        path="/services"
      />
      <div className="page-header">
        <div className="page-header-bg svc-bg"></div>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <p className="section-label">What We Offer</p>
          <h1 className="section-title">OUR SERVICES</h1>
        </div>
      </div>

      <section className="page-section">
        <div className="container">
          <p className="section-label">Choose Your Service</p>
          <h2 className="section-title">PRICING &amp; PACKAGES</h2>
          <div className="gold-line"></div>
          <p className="svc-intro">
            All services are performed at your location. Prices vary by vehicle size — contact us for a quote.
          </p>

          <div className="svc-cards">
            {SERVICES.map(s => {
              const Icon = s.icon;
              return (
              <div
                className={`svc-card ${s.popular ? 'svc-popular' : ''} ${active === s.id ? 'svc-open' : ''}`}
                key={s.id}
              >
                {s.popular && <div className="popular-badge">Most Popular</div>}
                <h3 className="svc-card-heading">
                  <button
                    type="button"
                    className="svc-card-header"
                    aria-expanded={active === s.id}
                    aria-controls={`svc-panel-${s.id}`}
                    onClick={() => setActive(active === s.id ? null : s.id)}
                  >
                    <span className="svc-emoji" aria-hidden="true"><Icon /></span>
                    <span className="svc-card-meta">
                      <span className="svc-card-title">{s.title}</span>
                      <span className="svc-tagline">{s.tagline}</span>
                    </span>
                    <span className="svc-price-block">
                      <span className="svc-price">From {s.price}</span>
                      <span className="svc-duration">{s.duration}</span>
                    </span>
                    <span className="svc-toggle" aria-hidden="true">{active === s.id ? '−' : '+'}</span>
                  </button>
                </h3>

                {active === s.id && (
                  <div className="svc-features" id={`svc-panel-${s.id}`} role="region" aria-label={`${s.title} details`}>
                    <ul>
                      {s.features.map((f, i) => (
                        <li key={i}><span className="check" aria-hidden="true"><LuCheck /></span>{f}</li>
                      ))}
                    </ul>
                    <button
                      className="btn-primary svc-book-btn"
                      onClick={() => navigate('reservations')}
                    >
                      Book This Service →
                    </button>
                  </div>
                )}
              </div>
              );
            })}
          </div>

          <div className="svc-note">
            <p>
              <LuLightbulb className="svc-note-icon" aria-hidden="true" />
              <strong>Combo deals available.</strong> Ask about bundling services for extra savings.
              <br />Vehicle size (sedan, SUV, truck) may affect pricing.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
